import { Controller } from '@hotwired/stimulus'

const EXTERNAL_LINK_SELECTOR = 'a[data-external-link]'

export default class AppBridgeController extends Controller {
  static values = { deepLink: String }

  connect () {
    if (!window.ReactNativeWebView) return

    this.handleExternalLinkClick = this.#handleExternalLinkClick.bind(this)
    this.element.addEventListener('click', this.handleExternalLinkClick)
  }

  disconnect () {
    if (this.handleExternalLinkClick) {
      this.element.removeEventListener('click', this.handleExternalLinkClick)
    }
  }

  share (event) {
    this.#emit(event, { type: 'share' })
  }

  menuButton (event) {
    this.#emit(event, { type: 'menuButton' })
  }

  openLink (event) {
    this.#emit(event, { type: 'openLink', url: this.element.href })
  }

  openAsset (event) {
    const t = event.currentTarget
    this.#emit(event, {
      type: 'openAsset',
      asset: {
        id: t.dataset.id,
        fileName: t.dataset.name,
        dataType: t.dataset.type,
        url: t.dataset.url
      }
    })
  }

  openLocalDocument (event) {
    this.#emit(event, { type: 'openLocalDocument', url: this.element.href })
  }

  navigate (event) {
    this.#emit(event, {
      type: 'navigate',
      deepLink: this.deepLinkValue,
      url: this.element.href
    })
  }

  contactInfo (event) {
    this.#emit(event, { type: 'contactInfo' })
  }

  // A webview drops a `target="_blank"` submit, so a GET form that opens a
  // file elsewhere is handed to the app as the link it would have followed.
  openFormLink (event) {
    const form = event.currentTarget
    const url = new URL(form.action)
    new FormData(form).forEach((value, name) => url.searchParams.append(name, value))

    this.#emit(event, { type: 'openLink', url: url.toString() })
  }

  #handleExternalLinkClick (event) {
    const anchor = event.target.closest(EXTERNAL_LINK_SELECTOR)
    if (!anchor) return

    event.preventDefault()
    const url = anchor.getAttribute('href') || ''
    window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'openLink', url }))
  }

  #emit (event, payload) {
    if (typeof window === 'undefined' || !window.ReactNativeWebView) return

    event.preventDefault()
    event.stopImmediatePropagation()
    window.ReactNativeWebView.postMessage(JSON.stringify(payload))
  }
}
